import { spacing } from '../../../../styles/spacing.css';
import { Layout } from '../../../Layout/Layout';
import * as styles from './CalendarViews.css';

export const WeekDaysLabels: React.FC<{ readonly weekDays: string[] }> = ({ weekDays }) => (
  <Layout as="tr" my={spacing.s08}>
    {weekDays.map((day, i) => (
      <Layout
        as="th"
        className={styles.weekDays}
        // eslint-disable-next-line react/no-array-index-key -- day are single letter like M, T, W, T, F, S, S
        key={i}
        padding={styles.CELL_PADDING}
        textAlign="center"
        width={styles.CELL_WIDTH}
      >
        {day}
      </Layout>
    ))}
  </Layout>
);
